import script from "./AddressSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressSection.vue?vue&type=script&setup=true&lang=js"

import "./AddressSection.vue?vue&type=style&index=0&id=1f7aaeeb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f7aaeeb"]])

export default __exports__